<div nz-row>
    <div nz-col nzSpan="6">
        <span class="pageTitle">Add New User</span>
    </div>
</div>
<br />
<div class="ant-advanced-search-form" style="margin-bottom: 10px;" id="searchContainer">
    <form [formGroup]="searchForm" (ngSubmit)="!userExist ? getUserDetails() : resetSearForm()" nz-form>
        <div nz-row [nzGutter]="24">
            <div nz-form-label nz-col [nzSpan]="3">
                <nz-form-label for="userType">User Type</nz-form-label>
            </div>
            <div nz-col [nzSpan]="4">
                <nz-select formControlName="userType" style="width: 150px;">
                    <nz-option nzValue="0" nzLabel="Chevron"></nz-option>
                    <nz-option nzValue="1" nzLabel="Non-Chevron"></nz-option>
                </nz-select>
            </div>

            <div nz-form-label nz-col [nzSpan]="5" nzRequired>
                <nz-form-label for="userSearch">Enter CAI/Logon Id/Email <span class="text-danger">*</span> </nz-form-label>
            </div>
            <div nz-form-control nz-col [nzSpan]="6">
                <input nz-input id="userSearch" formControlName="userSearch" />
                <!-- Validation Messages -->
                <!-- <div
                    *ngIf="searchForm.get('userSearch')?.touched && searchForm.get('userSearch')?.invalid">
                    <small class="text-danger" *ngIf="searchForm.get('userSearch')?.errors?.['required']">
                        CAI/Logon Id/Email is required.
                    </small>                    
                </div> -->
            </div>
            <div nz-form-control nz-col [nzSpan]="3">
                <button [disabled]="searchForm.invalid" nz-button nzType="primary" style="margin-right: 10px;">{{ buttonLabel }}</button>
            </div>
        </div>
        <div *ngIf="errorMessage" nz-row>
            <div nz-col [nzSpan]="24" class="text-danger" style="margin-top: 10px; text-align: center;">
                {{ errorMessage }}
            </div>
        </div>
    </form>

</div>
<div class="create-query-container" nzCompact *ngIf="userExist">
    <form [formGroup]="addUserForm" (ngSubmit)="onSubmit()" nz-form class="ant-advanced-search-form">
        <div nz-row [nzGutter]="24" style="margin-bottom: 10px;">
            <div nz-form-label nz-col [nzSpan]="3">
                <label for="userName">User Name</label>
            </div>
            <div nz-col [nzSpan]="6">
                <input nz-input id="userName" formControlName="userName" readonly />
            </div>
            <div nz-form-label nz-col [nzSpan]="2"></div>
            <div nz-form-label nz-col [nzSpan]="2">
                <label for="email">Email</label>
            </div>
            <div nz-form-control nz-col [nzSpan]="6">
                <input nz-input id="email" formControlName="email" readonly />
            </div>
        </div>

        <div nz-form-item nz-row [nzGutter]="24" style="margin-bottom: 10px;">
            <div nz-form-label nz-col [nzSpan]="3">
                <label for="cai">CAI</label>
            </div>
            <div nz-form-control nz-col [nzSpan]="6">
                <input nz-input id="cai" formControlName="cai" readonly />
            </div>
            <div nz-form-label nz-col [nzSpan]="2"></div>
            <div nz-form-label nz-col [nzSpan]="2">
                <label for="jobTitle">Job Title</label>
            </div>
            <div nz-form-control nz-col [nzSpan]="6">
                <input nz-input id="jobTitle" formControlName="jobTitle" readonly />
            </div>
        </div>

        <div nz-form-item nz-row [nzGutter]="24" style="margin-bottom: 10px;">
            <div nz-form-label nz-col [nzSpan]="3">
                <label for="ctn">CTN</label>
            </div>
            <div nz-form-control nz-col [nzSpan]="6">
                <input nz-input id="ctn" formControlName="ctn" readonly />
            </div>
        </div>
        <div nz-form-item nz-row [nzGutter]="24" *ngIf="isPartner" style="margin-bottom: 10px;">
            <div nz-form-label nz-col [nzSpan]="3">
              <label for="company">Company</label>
            </div>
            <div nz-form-control nz-col [nzSpan]="6">
              <nz-select id="company" formControlName="company" nzPlaceHolder="Select a company" style="width: 100%;">
                <nz-option *ngFor="let company of companyMaster" [nzValue]="company.Company_Code" [nzLabel]="company.Company_Name">
                </nz-option>
              </nz-select>
              <div *ngIf="addUserForm.get('company')?.touched && addUserForm.get('company')?.invalid" class="text-danger">
                Company is required.
              </div>
            </div>
            <div nz-form-label nz-col [nzSpan]="2"></div>          
            <div nz-form-label nz-col [nzSpan]="2">
              <label for="block">Block</label>
            </div>
            <div nz-form-control nz-col [nzSpan]="6">
              <nz-select id="block" formControlName="block" nzPlaceHolder="Select a block"  style="width: 100%;">
                <nz-option *ngFor="let block of blockMaster" [nzValue]="block.Block_Code" [nzLabel]="block.Block_Name">
                </nz-option>
              </nz-select>
              <div *ngIf="addUserForm.get('block')?.touched && addUserForm.get('block')?.invalid" class="text-danger">
                Block is required.
              </div>
            </div>
          </div>
        <div nz-form-item nz-row [nzGutter]="24">
            <div nz-form-label nz-col [nzSpan]="3">
                <label>Application Roles</label>
            </div>
            <div nz-form-control nz-col [nzSpan]="6" id="roleDiv">
                <!-- <select nz-input id="role" class="form-control" formControlName="role">
                    <option *ngFor="let priority of applicationRoles" [value]="priority">
                      {{applicationRolesMapping[role]}}
                    </option>
                  </select> -->
                <!-- <nz-checkbox-group [nzOptions]="checkboxOptions" (change)="onRolesChange($event)">
                </nz-checkbox-group> -->


                <label class="ant-checkbox-wrapper ant-checkbox-group-item ng-star-inserted"
                    *ngFor="let choice of checkboxOptions; let i=index">
                    <input nz-input type="checkbox" [value]="choice.value" (change)="onRolesChange($event)">
                    {{choice.label}}
                </label>

            </div>
        </div>

        <div nz-form-item nz-row>
            <div nz-form-control nz-col [nzSpan]="24">
                <button nz-button nzType="primary" [disabled]="addUserForm.invalid || selectedRoles.length == 0">Submit</button>
            </div>
        </div>
    </form>
</div>